<template>
  <main class="main">
    <div class="buttons">
      <router-link :to="{ name: 'ordre-fabrication-creation' }" custom v-slot="{ navigate }">
        <ButtonElement color="bordeaux" :icon="PhPlus" @click="navigate">
          Créer un ordre de fabrication
        </ButtonElement>
      </router-link>
    </div>

    <div class="cards" v-if="ordresFabrication.length">
      <CardComponent
        v-for="ordreFabrication in ordresFabrication"
        :key="ordreFabrication.id"
        :icon="PhScroll"
        title="OF"
      >
        <template #buttons>
          <router-link
            :to="{ name: 'ordre-fabrication-modification', params: { id: ordreFabrication.id } }"
            custom
            v-slot="{ navigate }"
          >
            <ButtonElement color="bordeaux" :icon="PhPen" size="small" @click="navigate"
              >Modifier</ButtonElement
            >
          </router-link>
        </template>
        <CardInfoComponent title="Client">{{
          ordreFabrication.client_raison_sociale
        }}</CardInfoComponent>
        <CardInfoComponent title="Créé le">{{
          frenchDate(ordreFabrication.date_creation)
        }}</CardInfoComponent>
        <CardInfoComponent title="Créé par">{{
          ordreFabrication.utilisateur_creation_nom
        }}</CardInfoComponent>
      </CardComponent>
    </div>
  </main>
</template>

<script setup lang="ts">
import '@/assets/css/components/_ordre-fabrication.css'
import { onMounted, type Ref, ref } from 'vue'
import { PhPen, PhPlus, PhScroll } from '@phosphor-icons/vue'
import frenchDate from '@/mixins/getFrenchDate.ts'
import type { OrdreFabricationGet } from '@/interfaces/OrdreFabrication.ts'
import { useLoadingStore } from '@/stores/loading.ts'
import { useCacheStore } from '@/stores/cache.ts'
import ButtonElement from '@/components/ButtonElement.vue'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

// données
const ordresFabrication: Ref<OrdreFabricationGet[]> = ref([])

// fonctions
async function getOrdresFabrication() {
  ordresFabrication.value = await cacheStore.getOrdresFabrication()
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getOrdresFabrication()
  } finally {
    loadingStore.stop()
  }
})
</script>
